import { createRouter, createWebHistory, RouterView } from "vue-router";

//import lib from '@/lib';

import Layout from "@/layouts/Layout.vue";

import Main from "@/pages/Main.vue";
import Login from "@/pages/Login.vue";
import Register from "@/pages/Register.vue";
import Users from "@/pages/Users.vue";
import UserAdd from "@/pages/UserAdd.vue";
import UserEdit from "@/pages/UserEdit.vue";
import UsersGroups from "@/pages/UsersGroups.vue";
import UsersGroupAdd from "@/pages/UsersGroupAdd.vue";
import UsersGroupEdit from "@/pages/UsersGroupEdit.vue";
import Projects from "@/pages/Projects.vue";
import ProjectAdd from "@/pages/ProjectAdd.vue";
import ProjectEdit from "@/pages/ProjectEdit.vue";
import ProfileSettings from "@/pages/ProfileSettings.vue";
import Settings from "@/pages/Settings.vue";

import PageNotFound from "@/pages/PageNotFound.vue";

const routes = [
	/*{
		path: '/',
		redirect: '/index',
	},*/
	{
		path: "/",
		component: Layout,
		children: [
			{
				path: "",
				component: Main,
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: "login",
				component: Login,
				meta: {
					guest: true,
				},
			},
			{
				path: "register",
				component: Register,
				meta: {
					guest: true,
					isRegister: true,
				},
			},
			{
				path: "users",
				component: RouterView,
				children: [
					{
						path: "",
						component: Users,
						meta: {
							requiresAuth: true,
							admin: true,
						},
					},
					{
						path: "groups",
						component: RouterView,
						children: [
							{
								path: "",
								component: UsersGroups,
								meta: {
									requiresAuth: true,
									admin: true,
								},
							},
							{
								path: ":id",
								component: UsersGroupEdit,
								meta: {
									requiresAuth: true,
									admin: true,
								},
							},
							{
								path: "add",
								component: UsersGroupAdd,
								meta: {
									requiresAuth: true,
									admin: true,
								},
							},
						],
					},
					{
						path: ":id",
						component: UserEdit,
						meta: {
							requiresAuth: true,
							admin: true,
						},
					},
					{
						path: "add",
						component: UserAdd,
						meta: {
							requiresAuth: true,
							admin: true,
						},
					},
				],
			},
			{
				path: "projects",
				component: RouterView,
				children: [
					{
						path: "",
						component: Projects,
						meta: {
							requiresAuth: true,
						},
					},
					{
						path: ":id",
						component: ProjectEdit,
						meta: {
							requiresAuth: true,
							admin: true,
						},
					},
					{
						path: "add",
						component: ProjectAdd,
						meta: {
							requiresAuth: true,
							admin: true,
						},
					},
				],
			},
			{
				path: "profile-settings",
				component: ProfileSettings,
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: "settings",
				component: Settings,
				meta: {
					requiresAuth: true,
					admin: true,
				},
			},

			{
				name: "page-not-found",
				path: ":pathMatch(.*)*",
				component: PageNotFound,
			},
		],
	},
	{
		path: "/logout",
		component: { render: () => null },
		beforeEnter(to, from) {
			storeInstance.state.app.auth.doLogout();
			return { path: "/login" };
		},
	},
];

const router = createRouter({
	history: createWebHistory(),
	routes,
	scrollBehavior(to, from, savedPosition) {
		// 1. Если браузер нажал "Назад/Вперед", возвращаем сохраненную позицию
		if (savedPosition) {
			return savedPosition;
		}

		// 2. Если в роуте прописано не скроллить — ничего не делаем
		if (to.meta.noScroll) {
			return false; // Сохраняет текущую позицию
		}

		// 3. По умолчанию всегда скроллим вверх
		return { top: 0, behavior: "smooth" }; // Можно добавить плавность
	},
});

router.beforeEach(async (to, from) => {
	// Ждем инициализации данных
	try {
		await Promise.all([
			storeInstance.state.app.doInitData(),
			storeInstance.state.app.auth.doInitData(),
		]);
	} catch (e) {
		console.error("Initialization failed", e);
	}

	const isAuth = storeInstance.state.app.auth.isAuth();
	const isAdmin = storeInstance.state.app.auth.isAdmin();
	const isRegisterEnabled = storeInstance.state.app.enableRegister;

	const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
	const requiresAdmin = to.matched.some((record) => record.meta.admin);
	const isGuestOnly = to.matched.some((record) => record.meta.guest);
	const isRegisterPage = to.matched.some((record) => record.meta.isRegister);

	if (isRegisterPage && !isRegisterEnabled) {
		return { name: "page-not-found" };
	}

	// Если нужен логин, а мы не вошли
	if (requiresAuth && !isAuth) {
		return {
			path: "/login",
			query: { nextUrl: to.fullPath }, // query надежнее для редиректов
		};
	}

	// Если нужна админка, а мы не админ
	if (requiresAdmin && (!isAuth || !isAdmin)) {
		return { path: "/" };
	}

	// Если роут только для гостей (логин/рега), а мы уже вошли
	if (isGuestOnly && isAuth) {
		return { path: "/" };
	}

	// В остальных случаях просто разрешаем переход (return true)
	return true;
});

export default router;
